"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amplifyHandlers = require("../amplifyHandlers");

/*
 * Jira Ticket:
 * Created Date: Fri, 10th Jan 2020, 15:08:35 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
var defaultGetPermissions = function defaultGetPermissions() {
  var permissions = JSON.parse(localStorage.getItem('permissions'));
  return permissions ? Promise.resolve(permissions) : Promise.reject();
};

var defaultCheckError = function defaultCheckError(error) {
  var status = error.status;

  if (status === 401 || status === 403) {
    localStorage.removeItem('permissions');
    return Promise.reject();
  }

  return Promise.resolve();
};

var buildAuthProvider = function buildAuthProvider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$login = _ref.login,
      _login = _ref$login === void 0 ? _amplifyHandlers.amplifyLogin : _ref$login,
      _ref$logout = _ref.logout,
      _logout = _ref$logout === void 0 ? _amplifyHandlers.amplifyLogout : _ref$logout,
      _ref$checkAuth = _ref.checkAuth,
      _checkAuth = _ref$checkAuth === void 0 ? _amplifyHandlers.amplifyCurrentSession : _ref$checkAuth,
      _ref$checkError = _ref.checkError,
      _checkError = _ref$checkError === void 0 ? defaultCheckError : _ref$checkError,
      _ref$getPermissions = _ref.getPermissions,
      _getPermissions = _ref$getPermissions === void 0 ? defaultGetPermissions : _ref$getPermissions;

  return {
    login: function login(params) {
      return _login(params);
    },
    logout: function logout(params) {
      return _logout(params);
    },
    checkAuth: function checkAuth(params) {
      return _checkAuth(params);
    },
    checkError: function checkError(error) {
      return _checkError(error);
    },
    getPermissions: function getPermissions(params) {
      return _getPermissions(params);
    }
  };
};

var _default = buildAuthProvider;
exports.default = _default;